module.exports = __webpack_public_path__ + "static/media/matching-score-win.0244b27f.png";